export enum AlertCategory {
  Gunshot = 'Gunshot',
  Holster = 'Holster',
  CewArm = 'CewArm',
  CewArc = 'CewArc',
  CewTrigger = 'CewTrigger',
  CewUnholstered = 'CewUnholstered',
  CewRaised = 'CewRaised',
  CewWarning = 'CewWarning',
  CewTriggerEnergize = 'CewTriggerEnergize',
  CewSwitchEnergize = 'CewSwitchEnergize',
  AsuFrontDoor = 'AsuFrontDoor',
  AsuFrontDoorDriver = 'AsuFrontDoorDriver',
  AsuFrontDoorPassenger = 'AsuFrontDoorPassenger',
  AsuRearDoor = 'AsuRearDoor',
  AsuRearDoorDriver = 'AsuRearDoorDriver',
  AsuRearDoorPassenger = 'AsuRearDoorPassenger',
  AsuLightbar = 'AsuLightbar',
  AsuLightbarCode1 = 'AsuLightbarCode1',
  AsuLightbarCode2 = 'AsuLightbarCode2',
  AsuLightbarCode3 = 'AsuLightbarCode3',
  AsuWeaponRack = 'AsuWeaponRack',
  AsuWeaponRack1 = 'AsuWeaponRack1',
  AsuWeaponRack2 = 'AsuWeaponRack2',
  AsuFrontDoors = 'AsuFrontDoors',
  AsuRearDoors = 'AsuRearDoors',
  AsuTrunk = 'AsuTrunk',
  AsuK9Door = 'AsuK9Door',
  AsuSwitch1 = 'AsuSwitch1',
  AsuSwitch2 = 'AsuSwitch2',
  AsuSiren = 'AsuSiren',
  AsuBreaks = 'AsuBreaks',
  VehicleAcceleration = 'VehicleAcceleration',
  VehicleVelocity = 'VehicleVelocity',
  WatchMeActivate = 'WatchMeActivate',
  WatchMeActivateMarked = 'WatchMeActivateMarked',
  WatchMeCancel = 'WatchMeCancel',
  WatchMeCancelMarked = 'WatchMeCancelMarked',
}
